export const PURCHASE_INSTALL_ID_KEY = "invoice_builder_purchase_install_id";

export type PurchaseInstallIdStorage = Pick<Storage, "getItem" | "setItem">;

export function readOrCreatePurchaseInstallId(
  storage: PurchaseInstallIdStorage | undefined = browserStorage(),
  createId = defaultPurchaseInstallId,
): string | null {
  if (!storage) return null;

  const existing = storage.getItem(PURCHASE_INSTALL_ID_KEY);
  if (existing && isSafePurchaseInstallId(existing)) return existing;

  const next = createId();
  if (!isSafePurchaseInstallId(next)) return null;
  storage.setItem(PURCHASE_INSTALL_ID_KEY, next);
  return next;
}

export function isSafePurchaseInstallId(value: string): boolean {
  return /^install_[A-Za-z0-9._:-]{8,107}$/.test(value);
}

function defaultPurchaseInstallId(): string {
  const random =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
  return `install_${random.replace(/[^A-Za-z0-9._:-]/g, "")}`;
}

function browserStorage(): PurchaseInstallIdStorage | undefined {
  if (typeof window === "undefined") return undefined;
  return window.localStorage;
}
